import { render, staticRenderFns } from "./ETC_NEONARVAL.vue?vue&type=template&id=0036164c"
import script from "./ETC_NEONARVAL.vue?vue&type=script&lang=js"
export * from "./ETC_NEONARVAL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports